import { TAttraction } from "../attractions";
import { ATTRACTION_TYPE } from "_common/attractions/type/attraction.type";
import { MEXICO_PROVINCES } from "_common/regions/regions";

export const quintanarooAttraction: TAttraction[] = [
    {
        name: "Cozumel International Airport (CZM)",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.5111968,
            lng: -86.9326822,
        },
        type: ATTRACTION_TYPE.AIRPORT,
    },
    {
        name: "Chetumal International Airport (CTM)",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 18.5065353,
            lng: -88.3267677,
        },
        type: ATTRACTION_TYPE.AIRPORT,
    },
    {
        name: "Aeropuerto Internacional de Tulum Felipe Carrillo Puerto (TQO)",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.1661543,
            lng: -87.6617959,
        },
        type: ATTRACTION_TYPE.AIRPORT,
    },
    {
        name: "Cancun International Airport (CUN)",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 21.0420102,
            lng: -86.8750472,
        },
        type: ATTRACTION_TYPE.AIRPORT,
    },
    {
        name: "Mayan Train - Cancun Airport",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 21.0281712,
            lng: -86.8739862,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Puerto Morelos",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.85596,
            lng: -86.9534103,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Playa del Carmen",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.6783199,
            lng: -87.1215155,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Tulum",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.2456586,
            lng: -87.4563203,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Tulum Airport",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.1516057,
            lng: -87.6446828,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Felipe Carrillo Puerto",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 19.5923423,
            lng: -88.0771769,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Bacalar",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 18.7085576,
            lng: -88.3997238,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Chetumal Airport",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 18.6083657,
            lng: -88.4423887,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Nuevo Xcán",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.8789597,
            lng: -87.7431178,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Leona Vicario",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.9797899,
            lng: -87.2015355,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Limones-Chacchoben",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 19.0278181,
            lng: -88.1205581,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "Mayan Train - Nicolás Bravo-Konhunlich",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 18.4531875,
            lng: -88.8818928,
        },
        type: ATTRACTION_TYPE.TRAIN_STATION,
    },
    {
        name: "ADO Tulum",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.2106411,
            lng: -87.6051156,
        },
        type: ATTRACTION_TYPE.BUS_STATION,
    },
    {
        name: "ADO Cancun Centro",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 21.1644513,
            lng: -86.9668149,
        },
        type: ATTRACTION_TYPE.BUS_STATION,
    },
    {
        name: "ADO Chetumal",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 18.5125469,
            lng: -88.3326034,
        },
        type: ATTRACTION_TYPE.BUS_STATION,
    },
    {
        name: "ADO Playa del Carmen",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.6228431,
            lng: -87.2152496,
        },
        type: ATTRACTION_TYPE.BUS_STATION,
    },
    {
        name: "ADO Tulum Airport",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.1667058,
            lng: -87.664045,
        },
        type: ATTRACTION_TYPE.BUS_STATION,
    },
    {
        name: "ADO Bacalar",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 18.6901343,
            lng: -88.392924,
        },
        type: ATTRACTION_TYPE.BUS_STATION,
    },
    {
        name: "ADO Puerto Morelos",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.8554043,
            lng: -86.9001604,
        },
        type: ATTRACTION_TYPE.BUS_STATION,
    },
    {
        name: "ADO Tourist Terminal Playa del Carmen",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.6226433,
            lng: -87.080054,
        },
        type: ATTRACTION_TYPE.BUS_STATION,
    },
    {
        name: "Hospital Costamed Cozumel",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.5036755,
            lng: -86.9423405,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Amerimed Cozumel",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.4982103,
            lng: -86.9377848,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "All Sea Medical Clinic",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.4743034,
            lng: -86.9731871,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Costamed Playa del Carmen",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.6213431,
            lng: -87.0904431,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "General Hospital of Playa del Carmen",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.6445382,
            lng: -87.0953548,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Hospiten Playa del Carmen",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.6165133,
            lng: -87.095058,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Amerimed Playa del Carmen",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.6324632,
            lng: -87.0804597,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Costamed Puerto Morelos",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.8526129,
            lng: -86.8986632,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Hospital de Tulum",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.2099236,
            lng: -87.4676474,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Costamed Tulum",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.2154242,
            lng: -87.4503028,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Hospital Comunitario de Tulum",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.2069224,
            lng: -87.4700542,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Cancun General Hospital",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 21.1961633,
            lng: -86.8763503,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Hospiten Cancun",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 21.1382046,
            lng: -86.8238165,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Hospital Joya Cancun",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 21.1037097,
            lng: -86.7648757,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Hospital Galenia",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 21.1361006,
            lng: -86.8274845,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Hospital Amerimed Cancun",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 21.1444365,
            lng: -86.8222963,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Hospital Playamed Cancun",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 21.1642947,
            lng: -86.8239979,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Hospital Azura Cancun",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 21.1621315,
            lng: -86.8304012,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Hospital Comunitario Bacalar",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 18.6783884,
            lng: -88.3887301,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Costamed Mahahual",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 18.7347525,
            lng: -87.6955474,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "General Hospital Chetumal",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 18.5170703,
            lng: -88.3040718,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Centro Médico De Chetumal",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 18.5243538,
            lng: -88.3118973,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Hospital General de Zona y Medicina Familiar No. 1 IMSS",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 18.5068117,
            lng: -88.3100352,
        },
        type: ATTRACTION_TYPE.HOSPITAL,
    },
    {
        name: "Playa Xpu-Ha",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.4707285,
            lng: -87.2581179,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Xcalacoco",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.6622996,
            lng: -87.0322186,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Langosta",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 21.1457161,
            lng: -86.7799815,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Las Palmas",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.1984842,
            lng: -87.4359668,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Paraiso",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.2035294,
            lng: -87.4313049,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Paamul",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.5220319,
            lng: -87.1921315,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Publica Puerto Morelos",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.8506156,
            lng: -86.8732722,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa El Cocal",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 21.2594089,
            lng: -86.7517728,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa del Niño",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 21.1939735,
            lng: -86.8060455,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Norte Isla Mujeres",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 21.2610351,
            lng: -86.750881,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Public Beach Playa del Carmen",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.6445891,
            lng: -87.0581196,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Centro Isla Mujeres",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 21.2564644,
            lng: -86.7506349,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Tiburon",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 21.2238021,
            lng: -86.7325798,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Punta Sur Isla Mujeres",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 21.2034228,
            lng: -86.7129005,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa de La Guadalupana",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 21.2212476,
            lng: -86.7221547,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Hermosa Caleta",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 21.2618172,
            lng: -86.7483013,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Mascotas",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 21.2234961,
            lng: -86.7237083,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Paraison Playa del Carmen",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.6432093,
            lng: -87.0561739,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Punta Esmeralda",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.6484143,
            lng: -87.0508096,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Pet Friendly Playa del Carmen",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.6414132,
            lng: -87.0574196,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Coco Beach",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.6367176,
            lng: -87.0582755,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Chemuyil",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.3521192,
            lng: -87.3374197,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Punta Carey Beach",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.3420172,
            lng: -87.3405539,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playita Tortuga",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.2150264,
            lng: -87.4278004,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Ruinas",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.2150264,
            lng: -87.4278004,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Faro",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.2099853,
            lng: -87.4288335,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Santa Fe",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.2083572,
            lng: -87.4288112,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Pescadores",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.20396,
            lng: -87.4291038,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Las Palmas",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.1985883,
            lng: -87.4347929,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Mangle",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.1899646,
            lng: -87.4396847,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Public Beach Hotel Zone Tulum",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.1760604,
            lng: -87.4453799,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Mirador Tulum",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.1729343,
            lng: -87.4459114,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Publica Roca",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.1705525,
            lng: -87.4475544,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Public Access Lagoon",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 18.6734613,
            lng: -88.3921954,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Lagoon Access Luis Antonio",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 18.6734613,
            lng: -88.3921954,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Public Access Lagoon",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 18.6734613,
            lng: -88.3921954,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Mahahual Beach",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 18.685186,
            lng: -87.7580176,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Maya Chan Beach",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 18.685186,
            lng: -87.7580176,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playas de Mahahual",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 18.685186,
            lng: -87.7580176,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Malecon Chetumal",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 18.4933779,
            lng: -88.5772682,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Punta San Angel",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 18.4933779,
            lng: -88.5772682,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Xahuayxol",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 18.6512221,
            lng: -88.0069028,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Maroma",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.7385025,
            lng: -87.2465973,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Las Rocas",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.4348011,
            lng: -86.9955522,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa El Cielo",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.4348011,
            lng: -86.9955522,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Casitas",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.4348011,
            lng: -86.9955522,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
    {
        name: "Playa Chen Rio",
        region: MEXICO_PROVINCES.QUINTANA_ROO,
        coordinates: {
            lat: 20.4348011,
            lng: -86.9955522,
        },
        type: ATTRACTION_TYPE.PUBLIC_BEACH,
    },
];
